import { z } from "zod";
import { NOTES_MAX, CONTACT_NAME_MAX } from "@shared/constants/validation.js";

export const IMMUNIZATION_NAME_MAX = 120;

// Calendar date as "YYYY-MM-DD" (matches the Drizzle `date` column, mode string).
const dateField = z
  .string()
  .trim()
  .regex(/^\d{4}-\d{2}-\d{2}$/, "Use YYYY-MM-DD format")
  .refine(
    (v) => {
      // Shape-valid but calendar-invalid dates (e.g. 2026-02-31, 2026-13-01) must
      // fail here as a 400, not reach the Postgres `date` column and 500. Parse as
      // UTC and require the round-trip to match, which rejects month/day rollover.
      const parsed = new Date(`${v}T00:00:00Z`);
      return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === v;
    },
    "Enter a real calendar date",
  )
  .nullable()
  .optional();

const providerField = z.string().trim().max(CONTACT_NAME_MAX).nullable().optional();
const notesField = z.string().trim().max(NOTES_MAX).nullable().optional();

export const createImmunizationSchema = z.object({
  vaccineName: z
    .string()
    .trim()
    .min(1, "Vaccine name is required")
    .max(IMMUNIZATION_NAME_MAX, "Vaccine name is too long"),
  dateAdministered: dateField,
  nextDueDate: dateField,
  provider: providerField,
  notes: notesField,
});

export const updateImmunizationSchema = z.object({
  vaccineName: z
    .string()
    .trim()
    .min(1, "Vaccine name is required")
    .max(IMMUNIZATION_NAME_MAX)
    .optional(),
  dateAdministered: dateField,
  nextDueDate: dateField,
  provider: providerField,
  notes: notesField,
});

export type CreateImmunizationInput = z.infer<typeof createImmunizationSchema>;
export type UpdateImmunizationInput = z.infer<typeof updateImmunizationSchema>;
